import { render, staticRenderFns } from "./EditProfile.vue?vue&type=template&id=49055e7f&scoped=true&"
import script from "./EditProfile.vue?vue&type=script&lang=js&"
export * from "./EditProfile.vue?vue&type=script&lang=js&"
import style0 from "./EditProfile.vue?vue&type=style&index=0&id=49055e7f&prod&lang=scss&scoped=true&"
import style1 from "./EditProfile.vue?vue&type=style&index=1&id=49055e7f&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49055e7f",
  null
  
)

export default component.exports